import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoaderApis } from "../../loaderApiList";
import { CommunicationService } from "../../services/communication/communication.service";
import { findIndex } from "lodash";
import { serverUrl } from "../../constants";

/**
 * Service to intercept api calls to show custom loaders
 */
@Injectable()
export class CustomLoaderService implements HttpInterceptor {
  private totalRequests = 0;

  constructor(private communicationService: CommunicationService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // removing query params
    const queryParamsArray = req.url.split("?");
    const reqStr = queryParamsArray[0];
    if (queryParamsArray.includes("hideSimpleLoader=true")) {
      return next.handle(req);
    }

    const index = LoaderApis.findIndex((x) =>
      reqStr.includes(`${serverUrl}${x.api}`)
    );

    if (index > -1) {
      // setting current api if its present in LoaderApis list to show custom loader
      this.totalRequests++;
      this.communicationService.setCurrentApis(LoaderApis[index]);
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (index > -1) {
          this.totalRequests--;
          if (this.totalRequests === 0) {
            // setting current apis null to hide the loader
            this.communicationService.setCurrentApis(null);
          }
        }
      })
    );
  }
}
